<template>
  <div class="row">
    <h5 class="col-12 h2 mb-2 mt-4">Conceitos </h5>
    <h5 class="card-title ml-3 text-uppercase text-muted mb-4 h5">Avaliação de risco e crédito do cliente</h5>
    <div class="content col-12">
      <!-- Colapse Concepts -->
      <collapse
        class="commercial-card mt-2"
        :multipleActive="false"
      >
        <collapse-item v-for="(concept, index) in concepts" :key="concept.id">
          <div slot="title" class="row">
            <h3 class="mb-0">{{ concept.name }}</h3>
          </div>
          <div v-for="topic in concept.topics" :key="topic.id">
            <h4 class="mb-0">{{ topic.name }}</h4>
            <div class="row">
              <base-progress class="progress-xs mt-3 mb-0 col-10" type="blue" :height="8" :value="getPuntuaction(topic.analisis, topic.interval)"></base-progress>
              <h5 class="card-title text-uppercase text-muted mb-0 ml-5">Pontuação {{ getPuntuaction(topic.analisis, topic.interval) }}</h5>
            </div>
            <h5 :class="[`text-${statusColor(topic.status).color}`,'card-title text-uppercase text-muted mb-3 mt-3']">
              <span class="card-title text-uppercase text-muted h5">Status do Conceito </span>{{ statusColor(topic.status).value }}
            </h5>
          </div>

          <div v-if="concept.topics.length > 0 ? true : false">
            <base-button
              outline
              type="secondary"
              style="max-height: 3rem"
              @click="getClientAnalyses(index)"
            >
              <span class="text-body">Atualizar pontuação</span>
              <i class="fa fa-eye mt-2 text-blue"></i>
            </base-button>
          </div>
           
          <div v-show="concept.topics.length > 0 ? false : true">
            <p>Não encontramos dados </p>
          </div>

          <modal :show.sync="registerPunctuation">
            <h5 class="modal-title mb-2" id="exampleModalLabel">{{ concept.name }}</h5>
            <h5 class="card-title text-uppercase text-muted mb-4 h5">Cálculo de nota e referências</h5>
            <div v-for="topic in concept.topics" :key="topic.id">
              <concept-form :topic="topic" :key="String(topic.selectedInterval)" :clientCriId="criClient.id" @topic-params="getTopic" :requiredField="requiredField"/>
            </div>
            <template slot="footer">
              <base-button type="secondary" class="mr-2" @click="registerPunctuation = false">Cancelar</base-button>
              <base-button type="purple" @click="save()">Salvar pontuações</base-button>
            </template>
          </modal>
        </collapse-item>
      </collapse>
    </div>
  </div>
</template>

<script>
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import BaseProgress from '@/components/BaseProgress';
import ConceptForm from "./ConceptForm"

export default {
  name: 'concepts',
  components: {
    Collapse,
    CollapseItem,
    BaseProgress,
    ConceptForm
  },
  props: {
    criClient: Object
  },
  data() {
    return {
      concepts: [],
      registerPunctuation: false,
      requiredField: false,
      topicsParams: []
    }
  },
  mounted () {
    this.getConcepts()
  },
  methods: {
    statusColor(status) {
      if (!status) {
        status = {}
        status.grade = 60
      }
      if (status.grade < 50 ) return {
        color: 'red',
        value: 'Bom'
      }
      else if (status.grade == 100) return  {
        color: 'green',
        value: 'Excelente'
      }
      else return {
        color: 'blue',
        value: 'Recebido'
      } 
    },
    getConcepts () {
      if (!this.criClient.code) {
        this.concepts = []
        return
      }

      this.$http.secured.get("/api/v1/credit_analysis/get_concepts", { params: { code: this.criClient.code }})
        .then((response) => { this.concepts = response.data })
        .catch((error) => (console.log(error, "Something went wrong")));
    },
    getTopic(value) {
      this.topicsParams.forEach((topic, index) => {
        if (topic.topic_concept_id == value.topic_concept_id) {
          this.topicsParams[index] = value
        }
      })

      if (!this.topicsParams.find(topic => topic.topic_concept_id == value.topic_concept_id)) {
        this.topicsParams.push(value)
      }

      this.topicsParams = [...new Set(this.topicsParams)]
    },
    getClientAnalyses (index) {
      this.registerPunctuation = true
      this.concepts[index].topics.map(topic => {
        if (topic.analisis && topic.analisis.interval_topic_concept_id) {
          return topic.selectedInterval = topic.interval.filter(interval => interval.id == topic.analisis.interval_topic_concept_id)
        }

        return {}
      })
    },
    getPuntuaction(analyse=null, intervals=null) {
      if (analyse == null) return 0

      const interval_id = analyse.interval_topic_concept_id
      return intervals.filter(interval => interval.id == interval_id)[0].grade
    },
    save() {
      this.registerPunctuation = false

      this.topicsParams.map(async (param) => {
        console.log('param', param)
        if(param.id) {
          await this.$http.secured.put("/api/v1/credit_analysis/update_client_analyses", param)
          .then(() => {
            this.requiredField = false
          })
          .catch((error) => {
            this.requiredField = true
            console.log(error, "Something went wrong")
          })
        } else {
          await this.$http.secured.post("/api/v1/credit_analysis/create_client_analyses", param )
          .then(() => {
            this.requiredField = false
          })
          .catch((error) => (console.log(error, "Something went wrong")));
        }
        
        this.getConcepts()
        this.topicsParams = []
      })
      
    }
  }
}
</script>
